import React from 'react';
import { ROW, COLUMN } from '../constants';
function checkIfRowHasColumns(type, children) {
  if (type !== ROW) return false;
  let hasColumn = false;
  React.Children.forEach(children, child => {
    const childrenElements = child.props.children;
    if (Array.isArray(childrenElements) && childrenElements.length) {
      const [, nestedChildren] = child.props.children;
      nestedChildren.forEach(nestedChild => {
        const nestedChildType = nestedChild.props.component.type;
        if (nestedChildType === COLUMN) hasColumn = true;
      });
    }
  });
  return hasColumn;
}
export default checkIfRowHasColumns;
//# sourceMappingURL=check-if-row-has-columns.js.map